import { Link, useLocation } from 'react-router-dom';

type CourseLinkProps = {
	courseId: string;
	children: React.ReactNode;
};

const CourseLink = ({ courseId, children }: CourseLinkProps) => {
	const location = useLocation();

	return (
		<Link
			to={`/dashboard/courses/${courseId}`}
			state={{ from: `${location.pathname}${location.search}` }}
			className="font-medium text-purple-900 underline-offset-2 hover:underline"
		>
			{children}
		</Link>
	);
};

export default CourseLink;
